"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nNotInitializedError = void 0;
class I18nNotInitializedError extends Error {
    constructor() {
        super('Attempted to translate before i18n was initialized');
        this.name = 'I18nNotInitializedError';
    }
}
exports.I18nNotInitializedError = I18nNotInitializedError;
//# sourceMappingURL=I18nNotInitializedError.js.map